module.exports = __webpack_public_path__ + "img/tornado.caccd7a6.gif";